export async function getOmnibusPriceFromAPI(brand, ID) {
  let jsonData;

  try {
    const response = await fetch(`https://omnibus.filoblu.com/?brand=${brand}&sku=${ID}&market=${window.location.host}${window.Shopify.routes.root}`);
    jsonData = await response.json();
  } catch (e) {
    return 0;
  }

  return jsonData.price;
};

export async function renderOmnibusPriceFromAPI(brand, price) {
  const omnibuspriceContainer = document.querySelectorAll(`[data-omnibus_brand="${brand}"]`)[0];

  if (!price) {
    hideOmnibuspriceContainer(omnibuspriceContainer);
    return;
  }

  omnibuspriceContainer.classList.remove('hidden');
  const omnibuspriceValue = omnibuspriceContainer.querySelector('.omnibusprice-value');
  omnibuspriceValue.innerText = window.theme.Currency.formatMoney(price.toFixed(2), window.theme.strings.moneyFormat);
};

export const hideOmnibuspriceContainer = (omnibuspriceContainer) => {
  if (!omnibuspriceContainer.classList.contains('hidden')) {
    omnibuspriceContainer.classList.add('hidden');
  }
}
